import { useFeatureFlags } from "@/hooks/useFeatureFlags";
import { usePathCheck } from "@/hooks/usePathCheck";
import { cn } from "@/lib/utils";
import { ClassAttributes, HTMLAttributes } from "react";

import { SideFooter } from "./Footer";
import { NavMenu } from "./NavMenu";

export const SideBar = ({
    className,
    ...props
}: ClassAttributes<HTMLElement> & HTMLAttributes<HTMLElement>) => {
    const { isFeatureEnabled } = useFeatureFlags();
    const isMypage = usePathCheck("/mypage");
    const isMypageOrders = usePathCheck("/mypage/orders");
    const isMypageCourses = usePathCheck("/mypage/courses");
    const isBookmark = usePathCheck("/bookmark*");
    const isSearch = usePathCheck("/search*");

    return (
        <aside
            className={cn(
                `sticky left-0 top-[var(--header-height)]
                mr-[var(--sidebar-margin)] flex h-[calc(100vh-120px)]
                w-[var(--sidebar-width)] flex-col justify-between gap-6`,
                className,
                isMypage ||
                    isMypageOrders ||
                    isMypageCourses ||
                    isBookmark ||
                    isSearch
                    ? "-mt-[30px]"
                    : "-mt-[68px]"
            )}
            {...props}
        >
            <NavMenu showSubMenu />
            {isFeatureEnabled("UI_HEADER_DROPDOWN") && <SideFooter />}
        </aside>
    );
};
